import React from "react";

const Delete = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M26 5.2h8v3.2h-3.2v24a1.6 1.6 0 01-1.6 1.6H6.8a1.6 1.6 0 01-1.6-1.6v-24H2V5.2h8V2h16v3.2zm-12.8 8V26h3.2V13.2h-3.2zm6.4 0V26h3.2V13.2h-3.2z"
            fill={fill}
      />
    </svg>
);

export default Delete;
